import { render, staticRenderFns } from "./labelPrint.vue?vue&type=template&id=16bf06ea&scoped=true"
import script from "./labelPrint.vue?vue&type=script&lang=js"
export * from "./labelPrint.vue?vue&type=script&lang=js"
import style0 from "./labelPrint.vue?vue&type=style&index=0&id=16bf06ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf06ea",
  null
  
)

export default component.exports